/// <reference path="../../../../../../typings/index.d.ts" />
/// <reference path="../meevomessenger.component.base.ts" />

module Meevo.Plugins.MeevoMessenger {
    class TextelController extends MessengerComponentBase {
        static $inject = [
            "$mdSidenav",
            "meevo.AppSettings",
            "meevo.components.common.BusinessInfoDataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.busy.BusyService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            "meevo.components.short-cuts.ShortCutsService",
            "$filter",
            "$translate",
            "$q",
            "meevo.plugins.meevoMessenger.meevoMessengerService",
            "meevo.plugins.meevoMessenger.meevoMessengerApiService",
            "$timeout",
            "meevo.components.common.SecurityService",
        ];

        public poweredByEntityName = "Textel";

        //initialize base class variables
        intialSettingsSectionName = "SECTION_TEXTEL";
        undeleteConversationType = UndeleteConversationTypesEnum.Textel;
        messageLengthLimit = Meevo.Plugins.MeevoMessenger.Constants.MESSAGE_SMS_LENGTH_LIMIT;

        constructor(
            protected $mdSidenav: ng.material.ISidenavService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: any,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected $filter: angular.IFilterService,
            protected $translate: angular.translate.ITranslateService,
            protected $q: angular.IQService,
            protected meevoMessengerService: IMeevoMessengerService,
            protected meevoMessengerApiService: IMeevoMessengerApiService,
            protected $timeout: angular.ITimeoutService,
            protected securityChecker: Meevo.Components.Common.ISecurityService
        ) {
            super(
                $mdSidenav,
                appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                busyService,
                $rootScope,
                $scope,
                $state,
                contextParams,
                shortCutsService,
                $filter,
                $translate,
                $q,
                meevoMessengerService,
                meevoMessengerApiService,
                $timeout,
                MeevoMessengerClassificationAPI.TEXTEL,
                securityChecker
            );

            this.notificationClassification = "TEXTEL";
        }

        initEventHandler(params) {
            // Call parent implementation first to keep existing subscriptions
            super.initEventHandler(params);

            // Add Textel specific subscription
            this.$scope.$on(Meevo.Components.Common.Messages.TEXTEL_MESSAGE_STATUS, (event: angular.IAngularEvent, msg: string) => {
                const msgData = JSON.parse(msg)
                this.changeMessageStatus(msgData);
            })

            this.$scope.$on(
                MeevoMessengerMessages.CLEAR_TEXTEL_SETTINGS_AND_AUTH,
                () => {
                    //TODO: review and change to name like MESSENGER?
                    this.meevoMessengerSettings = null;
                    this.isAccountInitialized = false;
                    this.conversationMessageList = null;
                    this.selectedConversation = null;
                }
            );

            this.$scope.$watch(() => this.selectedPhoneNumber, (phoneNumber) => {
                if (phoneNumber && phoneNumber.length == 10) {
                    this.activateByUser(!this.isClientMessaging, phoneNumber)
                }
            });
        }

        getOptOutStatus(): any { }
    }

    class TextelComponent implements angular.IComponentOptions {
        templateUrl = 'app/plugins/meevoMessenger/components/textel/index.html';
        controller = TextelController;
        controllerAs = 'meevoMessenger';
        bindings: any = {
            isAccountInitialized: '=',
            isAutoReplyEnabled: '=',
            sideNavClientInfo: '=',
            isPulsing: '=',
            isClientMessaging: '=',
        };
    }

    angular.module('meevo.plugins.meevoMessenger')
        .component('textelComponent', new TextelComponent());

}
